import { render, staticRenderFns } from "./T-F-Grad-2023-EN.vue?vue&type=template&id=04dab794&scoped=true&"
import script from "./T-F-Grad-2023-EN.vue?vue&type=script&lang=js&"
export * from "./T-F-Grad-2023-EN.vue?vue&type=script&lang=js&"
import style0 from "./T-F-Grad-2023-EN.vue?vue&type=style&index=0&id=04dab794&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dab794",
  null
  
)

export default component.exports